export const APP_RESET = "APP_RESET";
export const CLEAR_STORAGE = "CLEAR_STORAGE";
export const SET_LOADING = "SET_LOADING";
export const SET_TOGGLE = "SET_TOGGLE";
export const SET_MODAL = "SET_MODAL";
export const CLOSE_MODAL = "CLOSE_MODAL";
export const SET_SENDING_REQUEST = "SET_SENDING_REQUEST";
export const SET_CONFIRM = "SET_CONFIRM";
export const SET_ALERT = "SET_ALERT";
export const SET_DISPLAY_ALERT = "SET_DISPLAY_ALERT";
export const SET_ACTIVE_TAB = "SET_ACTIVE_TAB";
export const SET_BACK_URL = "SET_BACK_URL";
export const SET_SECRET_VIEW = "SET_SECRET_VIEW";
export const SET_PAYMENT_DATA = "SET_PAYMENT_DATA";
export const SET_TOKEN = "SET_TOKEN";
export const SET_USER = "SET_USER";
export const SET_WIDGETS = "SET_WIDGETS";
export const SET_QUICK_ACCESS = "SET_QUICK_ACCESS";
export const SET_FAVORITE_REPORTS = "SET_FAVORITE_REPORTS";
export const SET_OPEN_ALL_REPORTS = "SET_OPEN_ALL_REPORTS";
export const SET_CLOSE_ALL_REPORTS = "SET_CLOSE_ALL_REPORTS";
export const SET_SELECTED_REPORT_TYPE = "SET_SELECTED_REPORT_TYPE";
export const SET_OPEN_DRAWER = "SET_OPEN_DRAWER";
export const SET_TABLE_COLUMNS = "SET_TABLE_COLUMNS";
export const SET_TABLE_ORDER = "SET_TABLE_ORDER";
export const SET_FROM_DATE = "SET_FROM_DATE";
export const SET_TO_DATE = "SET_TO_DATE";
export const SET_EXPANDED_SIDEBAR = "SET_EXPANDED_SIDEBAR";
export const SET_EXPANDED_NOTIFICATION = "SET_EXPANDED_NOTIFICATION";
export const SET_FISCAL_YEARS = "SET_FISCAL_YEARS";
export const SET_FISCAL_YEAR = "SET_FISCAL_YEAR";
export const SET_GUIDE = "SET_GUIDE";
export const SET_GUIDE_DATA = "SET_GUIDE_DATA";
export const SET_DASHBOARD_GUIDE = "SET_DASHBOARD_GUIDE";
export const SET_CREDIT_BALANCE = "SET_CREDIT_BALANCE";
export const SET_APP_SETTINGS = "SET_APP_SETTINGS";
export const SET_IS_DEMO = "SET_IS_DEMO";
export const SET_LABEL_SETTINGS = "SET_LABEL_SETTINGS";
export const APP_FORCE_LOGOUT = "APP_FORCE_LOGOUT";
